import { gql } from "@apollo/client";

const ICD_CODE_FIELDS = `
  id
  code_id
  ascii_description
  gender
  is_secondary
  req_morphology
  status
`;

const icdCodes = {
  GET_ICD_CODES: gql`
    query GetIcdCodes10(
      $page: Int
      $limit: Int
      $search: String
      $status: String
      $gender: String
      $isSecondary: Boolean
    ) {
      getIcdCodes10(
        page: $page
        limit: $limit
        search: $search
        status: $status
        gender: $gender
        isSecondary: $isSecondary
      ) {
        codes {
          ${ICD_CODE_FIELDS}
        }
        pageInfo {
          currentPage
          totalPages
          totalCount
          limit
        }
      }
    }
  `,

  CREATE_ICD_CODE: gql`
    mutation CreateIcdCode10($input: IcdCode10Input!) {
      createIcdCode10(input: $input) {
        ${ICD_CODE_FIELDS}
      }
    }
  `,

  UPDATE_ICD_CODE: gql`
    mutation UpdateIcdCode10($codeId: String!, $input: IcdCode10Input!) {
      updateIcdCode10(code_id: $codeId, input: $input) {
        ${ICD_CODE_FIELDS}
      }
    }
  `,

  DELETE_ICD_CODE: gql`
    mutation DeleteIcdCode10($codeId: String!) {
      deleteIcdCode10(code_id: $codeId)
    }
  `,
};

export default icdCodes;
